import { Card, CardBody, Skeleton, Stack } from "@chakra-ui/react";

export function ClassesLoading() {
  return (
    <Stack>
      {new Array(5).fill(null).map((_, index) => {
        return (
          <Card height={150} key={index} textAlign="center">
            <CardBody>
              <Stack spacing={1} alignItems="center" h="full">
                <Skeleton height="14px" w="80px" />
                <Skeleton height="14px" w="65px" />
                <Skeleton height="14px" w="45px" />
                <Skeleton mt="auto" height="32px" w="80px" />
              </Stack>
            </CardBody>
          </Card>
        );
      })}
    </Stack>
  );
}
